<template>
    <router-view :key="$route.fullPath" />
</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        name: 'ui-launch-control',

        computed: {
            ...mapGetters('launchDay', { definitions: 'getDefinitions' })
        },

        created() {
            if (!(this.definitions && this.definitions.launchday && this.definitions.launchday_point_id)) {
                this.$router.push({ name: 'launch.management.computerServicePoint' })
            }
        },

        beforeDestroy() {
            this.$store.dispatch('launchDay/clearControl')
        }
    }
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>